import jsPDF from 'jspdf';
import { PDF_CONFIG } from './pdfConstants';

/**
 * إنشاء PDF من Canvas
 */
export const createPdfFromCanvas = (canvas: HTMLCanvasElement): jsPDF => {
  console.log('📋 جاري إنشاء ملف PDF...');

  const pdf = new jsPDF('p', 'mm', 'a4');
  const imgWidth = PDF_CONFIG.PAGE_WIDTH;
  const pageHeight = PDF_CONFIG.PAGE_HEIGHT;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;
  let heightLeft = imgHeight;
  let position = 0;

  // إضافة الصفحة الأولى
  const imgData = canvas.toDataURL('image/png', PDF_CONFIG.IMAGE_QUALITY);
  pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  // إضافة الصفحات الإضافية إذا لزم الأمر
  while (heightLeft >= 0) {
    position = heightLeft - imgHeight;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  return pdf;
};

/**
 * إنشاء Blob من PDF
 */
export const createPdfBlob = (pdf: jsPDF): Blob => {
  const pdfBlob = pdf.output('blob');
  console.log('📦 تم إنشاء PDF Blob، الحجم:', pdfBlob.size, 'bytes');
  
  if (!pdfBlob || pdfBlob.size === 0) {
    throw new Error('فشل في إنشاء PDF - البيانات فارغة');
  }
  
  return pdfBlob;
};